module.exports = __webpack_public_path__ + "img/features-timer.9aab97cf.png";